/** Converts a parsel AST to a selector string */
export function stringify(listOrNode) {
    if (typeof listOrNode === "string") {
        return listOrNode;
    }
    if (listOrNode === undefined || listOrNode === null) {
        return "";
    }
    if (Array.isArray(listOrNode)) {
        return listOrNode.map((node) => stringify(node)).join("");
    }
    if (listOrNode.type === "complex") {
        const space = listOrNode.combinator === " " ? "" : " ";
        return `${stringify(listOrNode.left)}${space}${listOrNode.combinator}${space}${stringify(listOrNode.right)}`;
    }
    else if (listOrNode.type === "compound") {
        return listOrNode.list.map((node) => stringify(node)).join("");
    }
    else if (listOrNode.type === "list") {
        return listOrNode.list.map((node) => stringify(node)).join(", ");
    }
    return listOrNode.content;
}
/** Checks if two parsel AST are equivalent */
export function astEqual(a, b) {
    if (a === null && b === null)
        return true;
    if (a === null || b === null)
        return false;
    if (a.type !== b.type)
        return false;
    if (a.type === "complex" && a.type === b.type) {
        return astEqual(a.left, b.left) && a.combinator === b.combinator && astEqual(a.right, b.right);
    }
    else if (a.type === "compound" && a.type === b.type) {
        return a.list.length === b.list.length && a.list.every((node, i) => astEqual(node, b.list[i]));
    }
    else if (a.type === "list" && a.type === b.type) {
        return a.list.length === b.list.length && a.list.every((node, i) => astEqual(node, b.list[i]));
    }
    else {
        return a.content === b.content;
    }
}
/** Given a parsed selector, applies a :not() pseudo token to exclude a specific node type  */
export function fixSelectorToExcludeType(parsed, toExclude) {
    if (parsed === null || typeof parsed === "string")
        return parsed;
    const tok = {
        type: "pseudo-class",
        name: "not",
        argument: toExclude,
        content: `:not(${toExclude})`,
        pos: [0, 0],
    };
    // Easy case: remove toExclude
    if (parsed.type === "type" && parsed.content === toExclude) {
        return null;
    }
    // Easy case: targets a type other than toExclude
    else if (parsed.type === "type" && parsed.content !== toExclude && parsed.content !== "*") {
        return parsed;
    }
    // Recurse down and add :not(toExclude) everywhere
    if (parsed.type === "list") {
        return {
            ...parsed,
            list: parsed.list.map((node) => fixSelectorToExcludeType(node, toExclude)).filter(Boolean),
        };
    }
    else if (parsed.type === "complex") {
        return {
            ...parsed,
            right: parsed.right && fixSelectorToExcludeType(parsed.right, toExclude),
        };
    }
    else if (parsed.type === "compound") {
        return {
            ...parsed,
            list: [...parsed.list, tok].filter(Boolean),
        };
    }
    else {
        return {
            type: "compound",
            list: [parsed, tok],
        };
    }
}
//# sourceMappingURL=rulesetUtils.js.map